module.exports = __webpack_public_path__ + "Icono_Contrasenia_126px.png";